var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,70.75A30.75,30.75,0,1,0,9.25,40,30.78487,30.78487,0,0,0,40,70.75Zm.53027-30.21973A.74762.74762,0,0,0,40.75,40V10.769A29.24492,29.24492,0,1,1,19.86975,61.1908ZM39.25,10.769V39.25H10.769A29.27409,29.27409,0,0,1,39.25,10.769ZM38.18945,40.75,18.8092,60.13025A29.13543,29.13543,0,0,1,10.769,40.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconData);
export default __webpack_public_path__ + "static/media/icon_data.a6fd12bb1e172016432a515a0ab652ec.svg";
export { ForwardRef as ReactComponent };